export enum DisclosureStage {
  ClosingDisclosure = "ClosingDisclosure",
  InvestorReview = "InvestorReview",
  PreAppLoanEstimate = "PreAppLoanEstimate",
  LoanEstimate = "LoanEstimate",
  PreliminaryClosingDisclosure = "PreliminaryClosingDisclosure",
  Redisclosure = "Redisclosure",
  UnderwritingPackage = "UnderwritingPackage",
}

// Currency values, as strings
export interface CashToClose {
  total_closing_costs: string;
  closing_costs_paid_before_closing: string;
  closing_costs_financed: string;
  down_payment: string;
  deposit: string;
  funds_for_borrower: string;
  seller_credits: string;
  adjustments_and_other_credits: string;
}
